import React, { useState } from 'react';
import './TrustFooter.css';

const REVIEWS = [
  { name: 'James R.', text: 'Honestly surprised how good this is. The conversations feel real and the photos are incredible. Legit service, been using it for weeks.', date: 'Feb 2026' },
  { name: 'Mike T.', text: 'Was skeptical at first but the support team helped me right away when I had a question about credits. Very responsive and professional.', date: 'Jan 2026' },
  { name: 'David L.', text: 'Best AI companion platform I\'ve tried. The character creator is amazing and the chat quality is on another level. Worth every credit.', date: 'Mar 2026' },
  { name: 'Chris W.', text: 'Payment was smooth through Stripe, got my credits instantly. The girls remember everything from previous chats which is impressive.', date: 'Feb 2026' },
  { name: 'Alex P.', text: 'Finally a platform that actually delivers what it promises. Photos look fantastic, chat is fun, and the whole experience feels premium.', date: 'Mar 2026' },
];

const LEGAL_PAGES = {
  terms: {
    title: 'Terms of Service',
    content: `Welcome to Bunny Crush.

Bunny Crush provides an AI-powered virtual companion service. All conversations and characters are generated by artificial intelligence. No real human operators are involved.

1. Eligibility
You must be at least 18 years old to use this service.

2. Credits & Payments
Access to chat and photo features requires credits purchased through our platform. Credits are non-transferable and have no cash value. All purchases are final unless otherwise required by law.

3. Digital Service Notice (EU Users)
By purchasing credits, you request immediate access to the digital service and acknowledge that you waive your 14-day right of withdrawal once access is granted.

4. Refund Policy
Refunds are available only if purchased credits have not been used. Once credits are spent (partially or fully), no refund will be issued. If you believe you were charged in error, please contact support.

5. AI Disclosure
Bunny Crush is an AI-based entertainment service. It does not provide therapy, medical advice, or professional counseling.

6. Limitation of Liability
The service is provided "as is" without warranties of any kind.`,
  },
  privacy: {
    title: 'Privacy Policy',
    content: `We respect your privacy.

Information We Collect
- Email address
- Account details
- Usage data
- Device information
- Cookies

Payments are processed securely by Stripe. We do not store card details.

How We Use Data
- To provide access to the service
- To process payments
- To improve user experience
- For analytics and advertising (if consent is given)

Third Parties
We may share necessary data with:
- Stripe (payment processing)
- Hosting providers
- Analytics and advertising platforms

Your Rights (EU Users)
You may request access, correction, or deletion of your personal data by contacting support.`,
  },
  refund: {
    title: 'Refund & Cancellation Policy',
    content: `You may cancel your account at any time.

Refunds are available only if your purchased credits have not been used. Once any credits from a purchase have been spent, that purchase is non-refundable.

If you believe you were charged in error, please contact our support team and we will investigate promptly.`,
  },
  ai: {
    title: 'AI Disclosure',
    content: `Bunny Crush is an AI-powered virtual companion platform.

All conversations, images, and interactions are generated by artificial intelligence.

No real individuals are involved in chat interactions.

Characters are fictional and created by users through our character builder. Any resemblance to real persons is entirely coincidental.`,
  },
  usc2257: {
    title: '18 U.S.C. 2257 Exemption Statement',
    content: `All content on this website is computer-generated and does not depict real human beings.

Therefore, Bunny Crush is exempt from the record-keeping requirements of 18 U.S.C. \u00A72257.

No actual persons were photographed or filmed in the creation of any content on this platform.`,
  },
};

function Stars() {
  return (
    <span className="tf-stars">
      {[...Array(5)].map((_, i) => (
        <svg key={i} width="14" height="14" viewBox="0 0 24 24" fill="#facc15" stroke="none">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
      ))}
    </span>
  );
}

function LegalModal({ page, onClose }) {
  const legal = LEGAL_PAGES[page];
  if (!legal) return null;

  return (
    <div className="overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal" style={{ maxWidth: '560px' }}>
        <button className="modal-close" onClick={onClose}>&#x2715;</button>
        <h2 className="modal-title" style={{ fontSize: '1.4rem' }}>{legal.title}</h2>
        <div className="tf-legal-content">
          {legal.content.split('\n').map((line, i) => (
            <p key={i}>{line}</p>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function TrustFooter({ prominent = false }) {
  const [legalPage, setLegalPage] = useState(null);

  return (
    <>
      <footer className={`tf-footer ${prominent ? 'tf-prominent' : ''}`}>
        {/* Reviews moved to landing page slider — kept here for future use
        {prominent && (
          <div className="tf-reviews">
            <div className="tf-reviews-header">
              <Stars />
              <span className="tf-rating">4.9 / 5</span>
              <span className="tf-rating-sub">from 2,400+ users</span>
            </div>
            <div className="tf-reviews-scroll">
              {REVIEWS.map((r, i) => (
                <div key={i} className="tf-review-card">
                  <div className="tf-review-top">
                    <Stars />
                    <span className="tf-review-date">{r.date}</span>
                  </div>
                  <p className="tf-review-text">{r.text}</p>
                  <div className="tf-review-author">{r.name}</div>
                </div>
              ))}
            </div>
          </div>
        )}
        */}

        <div className="tf-links">
          <div className="tf-trust-badges">
            <span className="tf-badge">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
              Secure payments via Stripe
            </span>
            <span className="tf-badge">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 12l2 2 4-4"/><circle cx="12" cy="12" r="10"/></svg>
              AI-generated content only
            </span>
            <span className="tf-badge">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"/><path d="M2 12h20"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
              18+ only
            </span>
          </div>
          <div className="tf-legal-links">
            <button onClick={() => setLegalPage('terms')}>Terms</button>
            <span className="tf-dot" />
            <button onClick={() => setLegalPage('privacy')}>Privacy</button>
            <span className="tf-dot" />
            <button onClick={() => setLegalPage('refund')}>Refund Policy</button>
            <span className="tf-dot" />
            <button onClick={() => setLegalPage('ai')}>AI Disclosure</button>
            <span className="tf-dot" />
            <button onClick={() => setLegalPage('usc2257')}>2257 Statement</button>
          </div>
          <div className="tf-contact">
            Contact: <a href="mailto:support.bunnycrush@gmail.com">support.bunnycrush@gmail.com</a>
          </div>
          <div className="tf-copy">
            &copy; {new Date().getFullYear()} Bunny Crush. All rights reserved.
          </div>
        </div>
      </footer>

      {legalPage && <LegalModal page={legalPage} onClose={() => setLegalPage(null)} />}
    </>
  );
}
